import React, { useState } from "react";
import { connect } from "react-redux";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  Form,
  Input,
  InputNumber,
  Checkbox,
  Drawer,
  Button,
  Col,
  Row,
  Select,
  message,
} from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateNewContact = ({ bill, onNotesUpdate }) => {
  const initial = { remarks: "" };
  const [visible, setVisible] = useState(false);
  const [hasNotes, setHasNotes] = useState(false);
  const [form] = Form.useForm();

  const showDrawer = () => {
    if (bill.current.remarks) {
      form.setFieldsValue({ remarks: bill.current.remarks });
    }
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const onFinish = (values) => {
    bill.current.remarks = values.remarks;
    setHasNotes(!!values.remarks);
    setVisible(false);
    
    if (onNotesUpdate) {
      onNotesUpdate(values.remarks);
    }
    
    message.success("Notes added successfully");
  };

  return (
    <>
      <Button 
        type="link" 
        onClick={showDrawer} 
        style={{ paddingLeft: "0px" }}
        icon={hasNotes ? <EditOutlined /> : <PlusOutlined />}
      >
        {hasNotes ? "Edit Notes" : "Add Notes"}
      </Button>
      <Drawer
        title="Notes"
        width={500}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={initial}
        >
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="remarks"
                label="Remarks"
                style={{ minHeight: "60vh" }}
              >
                <ReactQuill 
                  theme="snow" 
                  preserveWhitespace={true} 
                  style={{ height: "50vh" }} 
                />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Button onClick={onClose} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit">
              {hasNotes ? "Update" : "Add"}
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default connect(null)(CreateNewContact);